import { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row, } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Dropzone from 'react-dropzone-uploader';
import NoImage from '../../assets/images/noimage.png';
import { isOpenModal, ModalToggle, fetchSliders, addSlider, deleteSlider, editSlider } from '../../store/slidersSlice';
import Pagination from '../../Components/Pagination/Pagination';
import SweetAlert from 'sweetalert2';
import Empty from '../../Components/Empty/Index';
import { getCategory } from '../../store/categorySlice';
import { getTestSeries } from '../../store/testSeriesSlice';

const SliderTable = () => {
  const storeVar = useSelector(state => state.sliders)
  const categoryVar = useSelector(state => state.category)
  const examVar = useSelector(state => state.testSeries)

  const dispatch = useDispatch();
  const location = useLocation();
  const toggle = () => dispatch(ModalToggle());
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    sliderId: '',
    bannerFile: null,
    bannerImageURL: null,
    type: "internal",
    examSeries: "",
    internalLink: '',
    externalLink: "",
    priority: 100,

  });

  useEffect(() => {
    dispatch(fetchSliders(formVar.limit, formVar.offset,));
    dispatch(getCategory(100, 0, 'active', ''))

  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(fetchSliders(formVar.limit, offset));

  };

  const BannerDelete = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteSlider(data._id))

        }
      });
  }


  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Sliders',
      bannerFile: null,
      bannerImageURL: null,
      type: "internal",
      internalLink: "",
      externalLink: "",
      examSeries: "",
      priority: 100,

    }))
  }

  const EditToggleModal = (item) => {
    dispatch(isOpenModal(true));
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      sliderId: item._id,
      modalTitle: 'Edit Slider',
      bannerFile: null,
      bannerImageURL: item.image || null,
      type: item.type || 'internal',
      internalLink: item.type === 'internal' ? (item.internalLink?._id || item.internalLink || '') : '',
      externalLink: item.type === 'external' ? (item.externalLink || '') : '',
      examSeries: item.type === 'internal' ? (item.internalLink?.categoryId || '') : '',
      priority: item.priority !== undefined ? item.priority : 100,
    }));

    if (item.type === 'internal') {
      const categoryId = item.internalLink?.categoryId || '';
      if (categoryId) {
        dispatch(getTestSeries(100, 0, 'active', '', categoryId));
      }
    }
  };


  const submitSlider = () => {

    if (linkValid() || filesValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      const payload = {
        type: formVar.type,
        priority: formVar.priority,
      };
      if (formVar.type === "internal") {
        payload.internalLink = formVar.internalLink;
      } else {
        payload.externalLink = formVar.externalLink;
      }
      dispatch(editSlider(formVar.sliderId, payload, formVar.bannerFile))
    } else {
      const payload = {
        type: formVar.type,
        priority: formVar.priority,
        bannerFile: formVar.bannerFile
      };
      if (formVar.type === "internal") {
        payload.internalLink = formVar.internalLink;
      } else {
        payload.externalLink = formVar.externalLink;
      }
      dispatch(addSlider(payload, formVar.bannerFile))
    }
  }


  const linkValid = () => {
    if (formVar.type === "internal" && !formVar.internalLink) {
      return "Please select an internal link";
    }
    if (formVar.type === "external" && !formVar.externalLink) {
      return "Please enter external link";
    }
    return null;
  };


  const filesValid = () => {
    if (!formVar.editState && !formVar.bannerFile) {
      return "Image is required";
    }
    return null;
  }



  // called every time a file's `status` changes
  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };
  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, examSeries: e.target.value, internalLink: "" }))
    dispatch(getTestSeries(100, 0, 'active', '', e.target.value))
  };
  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="5">
              </Col>
              <Col md="4">
              </Col>
              <Col md="3" className='d-flex justify-content-end align-items-center'>

                <div className="text-end border-2">
                  <Btn attrBtn={{ color: 'info-gradien', size: 'sm', onClick: AddToggleModal }}>
                    Add Sliders
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Priority</th>
                  <th scope='col'>Type</th>
                  <th scope='col'>Link</th>
                  <th scope='col'>Image</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar?.slidersData?.map((item, index) => (
                  <tr key={item._id}>
                    <th scope='row'>{index + 1}</th>
                    <td>
                      <span className="badge bg-primary px-2 py-1 font-bold">
                        {item.priority !== undefined ? item.priority : 100}
                      </span>
                    </td>
                    <td>{item.type}</td>
                    <td>{item?.internalLink?.title || item?.externalLink}</td>
                    <td className='w-25'>
                      {item.image ? <img className='w-75 h-5-r' src={item.image} alt="" /> : <img className='w-75 h-5-r' src={NoImage} alt="" />}
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer font-primary action-icon me-2'>
                          <i className="fa fa-pencil fa-lg" onClick={(e) => EditToggleModal(item)} />
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => BannerDelete(item)} />
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.slidersCount <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.slidersCount > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.slidersCount}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>

      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Priority</Label>
            <Input 
              className="form-control" 
              type="number" 
              placeholder="Enter priority (default: 100)" 
              value={formVar.priority} 
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, priority: e.target.value }))} 
            />
          </FormGroup>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Type</Label>
            <Input className="form-control form-control-inverse btn-square" name="select" type="select"
              value={formVar.type} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, type: e.target.value }))}>
              <option value='internal'>Internal</option>
              <option value='external'>External</option>
              <option value='none'>No Link</option>
            </Input>
            {formVar.type === "internal" &&
              <>
                <Label className="col-form-label" for="recipient-name">Exam Series</Label>
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.examSeries} onChange={handleInputChange}>
                  <option value="" >Select Exam Series</option>
                  {categoryVar?.categoryData?.map((item, index) => (
                    <option key={index} value={item._id}>{item.name}</option>
                  ))}
                </Input>
                {formVar.examSeries && <>
                  <Label className="col-form-label" for="recipient-name">Exam</Label>
                  <Input className="form-control" type="select" placeholder='Enter Link'
                    onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, internalLink: e.target.value }))}
                    value={formVar.internalLink} >
                    <option value="" >Select Exam</option>
                    {examVar.testSeriesData?.map((item, index) => (
                      <option value={item._id} key={index} >{item.title}</option>
                    ))}

                  </Input>
                </>
                }
              </>
            }
            {formVar.type === "external" &&
              <>
                <Label className="col-form-label" for="recipient-name">Link</Label>
                <Input className="form-control" type="text" placeholder='Enter Link' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, externalLink: e.target.value }))} value={formVar.externalLink} />
              </>}
            {submit && linkValid() ? <span className='d-block font-danger'>{linkValid()}</span> : ""}
            <FormGroup>
              <Label className="col-form-label" for="recipient-name">Update Image</Label>
              <Dropzone
                className='dropzone dz-clickable'
                onChangeStatus={handleChangeStatus}
                maxFiles={1}
                multiple={false}
                // canCancel={false}
                accept="image/*"
                inputContent='Drop A File'
                styles={{
                  dropzone: { width: '100%', height: 150 },
                  dropzoneActive: { borderColor: 'green' },
                }}
              />
              {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
            </FormGroup>
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitSlider }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default SliderTable;
